import { Pipe, PipeTransform } from '@angular/core';
import { normalizerFactory } from '../../../helpers/transformation-utils';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({
    name: 'transformData',
    standalone: false
})
export class TransformData implements PipeTransform {
  transform(data: any): any {
    const MAGNITUDE_PER_X: { [key: string]: number } = {};
    const RAW_RESULT: { [key:string]: { data: number[], label: string } } = {}
    let MAX_X_LEN = -1;
    let MAX_Y_LEN = -1;
    let rulito = 0;
    data.forEach((entry) => {
      const current_x = entry.x;
      const current_y = entry.y;

      MAGNITUDE_PER_X[current_x] = MAGNITUDE_PER_X[current_x]
        || data.filter(f => f.x === current_x)
          .reduce((accum, rEntry) =>
            accum + rEntry.value, 0
          );

      RAW_RESULT[current_y] = RAW_RESULT[current_y] || { data: [], label: current_y };

      const doNormalize = normalizerFactory(0, MAGNITUDE_PER_X[current_x]);
      const val = doNormalize(entry.value) * 100 || 0;
      RAW_RESULT[current_y].data.push(Number(this.toTwoDecimal(val)));

      MAX_X_LEN = Math.max(MAX_X_LEN, RAW_RESULT[current_y].data.length);
      MAX_Y_LEN = Math.max(MAX_Y_LEN, Object.keys(RAW_RESULT).length);
    }, []);

    /* ETIQUETAS */
    const final_result = Object.values(RAW_RESULT).sort((a, b) => {
      const A_LABEL_ARR = a.label.split("-");
      const B_LABEL_ARR = b.label.split("-");
      return Number(A_LABEL_ARR[0]) - Number(B_LABEL_ARR[0]); 
    });

    for(let current_x = 0; current_x < MAX_X_LEN; current_x++) {
      let current_y_sum = 0;
      for(let current_y = 0; current_y < MAX_Y_LEN; current_y++){
        /* Normalizar los resultados, y mantenerlos entre 0 y 100. */
        if (current_y_sum + this.toTwoDecimal(final_result[current_y].data[current_x]) < 100){
          final_result[current_y].data[current_x] = this.toTwoDecimal(final_result[current_y].data[current_x]);
        } else {
          final_result[current_y].data[current_x] = this.toTwoDecimal(100 - current_y_sum);
        }
        /* Sumar parciales para no pasar el valor 100. */
        if(current_y < MAX_Y_LEN - 1) {
          current_y_sum = this.toTwoDecimal(current_y_sum + final_result[current_y].data[current_x]);
        }
      }
    }
    return final_result
  }


  /* Function to truncate the decimals to avoid errors */
  toTwoDecimal(numero: number){
    let num = numero.toString();
    let newString = "";
    let modified = false;
    for (let i=0; i<num.length-1; i++) {
      newString = newString.concat(num.charAt(i));
      if(num.charAt(i) === "."){
        newString = newString.concat(num.charAt(i+1));
        newString = newString.concat(num.charAt(i+2));
        modified = true;
        break;
      }
    }
    if (modified) {
      return Number (newString);
    }else{
      return numero;
    }
  }

}
